import { ref, reactive, watch } from '@vue/composition-api'

export default function useGenerateCards(props, ctx) {
  const cardsBatch = reactive({
    vendorId: null,
    numberOfCards: null,
    amountPerCard: null,
    expiryDate: null,
    userType: 'driver',
  })
  const userTypes = ['user', 'driver']
  const vendors = ref([])
  const vendorsLoading = ref(false)
  const fetchVendors = async () => {
    try {
      vendorsLoading.value = true
      const res = await ctx.root.$store.dispatch('vendors/fetchVendors')
      vendors.value = res
    } finally {
      vendorsLoading.value = false
    }
  }
  const generateCardsRef = ref(null)
  const generatingCards = ref(false)
  const submit = async e => {
    e.preventDefault()
    const valid = await generateCardsRef.value.validate()
    if (valid) {
      try {
        generatingCards.value = true
        if (props.editInfo) {
          await ctx.root.$store.dispatch('voucherCards/updateCard', {
            id: props.editInfo.id,
            expiryDate: cardsBatch.expiryDate,
            active: cardsBatch.active,
          })
        } else {
          await ctx.root.$store.dispatch('voucherCards/createCards', cardsBatch)
        }
        ctx.root.$bvModal.hide('voucher-generate-cards')
      } finally {
        generatingCards.value = false
      }
    }
  }
  watch(() => props.editInfo, () => {
    if (props.editInfo) {
      cardsBatch.expiryDate = props.editInfo.expiryDate
      cardsBatch.active = props.editInfo.active
    } else {
      cardsBatch.expiryDate = null
      delete cardsBatch.active
    }
  })
  fetchVendors()

  return {
    vendors,
    vendorsLoading,
    userTypes,
    cardsBatch,
    submit,
    generateCardsRef,
    generatingCards,
  }
}
